import { render, staticRenderFns } from "./AddPackageInKidsDialog.vue?vue&type=template&id=ae315192&scoped=true"
import script from "./AddPackageInKidsDialog.vue?vue&type=script&lang=js"
export * from "./AddPackageInKidsDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPackageInKidsDialog.vue?vue&type=style&index=0&id=ae315192&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae315192",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae315192')) {
      api.createRecord('ae315192', component.options)
    } else {
      api.reload('ae315192', component.options)
    }
    module.hot.accept("./AddPackageInKidsDialog.vue?vue&type=template&id=ae315192&scoped=true", function () {
      api.rerender('ae315192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/AddPackageInKidsDialog.vue"
export default component.exports